const STORAGE_ADDON_BUNDLE_ID = "6mIxWwEdRuhVxzqdigbEP2";
const STORAGE_ADDON_PRODUCT_ID = "6P8Y5FRcVGAZevJxnmvn7L";
const BACKUP_ID = "01GWAWKQHA3SY3CKS55R24FHKX";
const STANDALONE_BUNDLE_ID = "5yQVvmfldmu0m2uji289sv";
const STANDALONE_PRODUCT_ID = "3JPZAh5zCwZJB4VeNNhMVo";
// Same CMS product ID; STANDALONE_* = on-hold bundle path, BIDIRECTIONAL_* = solar accessory.
const STANDALONE_EV_CHARGER_PRODUCT_ID = "6KegsIDVA2GiV7jcwIgveg";
const BIDIRECTIONAL_EV_CHARGER_PRODUCT_ID = "6KegsIDVA2GiV7jcwIgveg";
const STANDALONE_EV_CHARGER_BUNDLE_ID = "7ckSpHYdfiEdZoSU0vUIcF"; // on hold

const SHIFT_PRODUCT_ID = "01GWAWVWF6W042FDF48WE1FCFK";
const SOLAR_PRODUCT_ID = "01GVPR696VA8FYBW8AHF1JJVA9";
const EV_CHARGER_PRODUCT_ID = "01GWAWXKPEPMAF1VR0KT4ZF7X8";
const POWER_MANAGEMENT_PRODUCT_ID = "01GWAX49QSDK48246J410J4RMA";
const NON_EXPORT_BACKUP_PRODUCT_ID = "2bCkdQEKjDrPzq7bxcXuD7";

/** Product display order: batteries → solar panels → EV charger → others */
const PRODUCT_DISPLAY_ORDER = {
  BATTERIES: [
    BACKUP_ID,
    STORAGE_ADDON_PRODUCT_ID,
    STANDALONE_PRODUCT_ID,
    SHIFT_PRODUCT_ID,
    NON_EXPORT_BACKUP_PRODUCT_ID,
  ],
  SOLAR: SOLAR_PRODUCT_ID,
  EV_CHARGER: [EV_CHARGER_PRODUCT_ID, BIDIRECTIONAL_EV_CHARGER_PRODUCT_ID],
} as const;

export {
  STORAGE_ADDON_BUNDLE_ID,
  STORAGE_ADDON_PRODUCT_ID,
  STANDALONE_BUNDLE_ID,
  STANDALONE_PRODUCT_ID,
  BACKUP_ID,
  STANDALONE_EV_CHARGER_BUNDLE_ID,
  STANDALONE_EV_CHARGER_PRODUCT_ID,
  BIDIRECTIONAL_EV_CHARGER_PRODUCT_ID,
  SHIFT_PRODUCT_ID,
  SOLAR_PRODUCT_ID,
  EV_CHARGER_PRODUCT_ID,
  POWER_MANAGEMENT_PRODUCT_ID,
  NON_EXPORT_BACKUP_PRODUCT_ID,
  PRODUCT_DISPLAY_ORDER,
};
